export default function HomeTwoContact(){
    return(
        <>
            <section className="heding-bg2 contact-area contact-bg pt-120 pb-120 pt-md-60 pb-md-60 pt-xs-60 pb-xs-60">
			<div className="container">
				<div className="row">
					<div className="col-xxl-6 col-xl-4 col-lg-4 mb-55">
						<div className="section-title">
							<h6 className="semi-title text-white px-0">Get In Touch</h6>
							<h2 className="sect-title text-white">Let's help you!</h2>
						</div>
					</div>
					<div className="col-xxl-3 col-xl-4 col-lg-4 mb-30">
						<div className="short-info theme-bg2">
							<div className="icon">
								<img src="assets/img/contact/telephone.png" alt="Icon" />
							</div>
							<div className="info-content">
								<h6>Phone Number</h6>
								<h5>908. 098. 908. 98</h5>
							</div>
						</div>
					</div>
					<div className="col-xxl-3 col-xl-4 col-lg-4 mb-30">
						<div className="short-info violet-bg">
							<div className="icon">
								<img src="assets/img/contact/mail.png" alt="Icon" />
							</div>
							<div className="info-content">
								<h6>Email Address</h6>
								<h5>info@webmail.com</h5>
							</div>
						</div>
					</div>
				</div>
				<div className="contact-input-wrapper row align-items-center">
					<div className="col-lg-7">
						<form className="row contact-form mb-30 pr-45 pr-lg-0 pr-md-0 pr-xs-0" action="#">
							<div className="col-lg-6 col-md-6">
								<div className="input-box mb-20">
									<input type="text" placeholder="Full name" />
								</div>
							</div>
							<div className="col-lg-6 col-md-6">
								<div className="input-box mail-input mb-20">
									<input type="text" placeholder="Email address" />
								</div>
							</div>
							<div className="col-lg-12 mb-20">
								<div className="input-box sub-input">
									<select name="job" className="job-select">
										<option value="Subject">Subject</option>
										<option value="">It</option>
										<option value="">Development</option>
										<option value="">Ui/Ux</option>
									</select>
								</div>
							</div>
							<div className="col-12">
								<div className="input-box text-input mb-15">
									<textarea name="message" cols="30" rows="10" placeholder="Enter massge"></textarea>
								</div>
							</div>

							<div className="col-12">
								<button className="form-btn">Get Free Consultation</button>
							</div>
						</form>
					</div>
					<div className="col-lg-5 ps-lg-0">
						<div className="map-area mb-30">
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14586.16663307975!2d90.3865062!3d23.941279099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1641645837442!5m2!1sen!2sbd"
								 loading="lazy"></iframe>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}